import React from 'react';
import css from 'styled-jsx/css';
import classnames from 'classnames';
import { colors } from '../Theme';

const svgStyles = css`
  .icon {
    width: 24px;
    height: 24px;
    stroke: ${colors.ywgNavy};
  }
`;

const SvgIcon = ({ children, className, title, ...props }) => {
  const iconClassName = classnames('icon', className);
  return (
    <svg viewBox="0 0 24 24" className={iconClassName} role="img" {...props}>
      <title>{title}</title>
      {children}
      <style jsx>{svgStyles}</style>
    </svg>
  );
};

const TrashIcon = props => (
  <SvgIcon {...props}>
    <path
      fill="none"
      d="M5.5 7v13c0 1 .5 1.5 1.5 1.5h10c1 0 1.5-.6 1.5-1.5V7M19.5 4H16l-2-2h-4L8 4H4.5v1h15V4z"
    />
    <path d="M9 10h1v9.5H9zM14 10h1v9.5h-1z" />
  </SvgIcon>
);

const editStyles = css.resolve`
  .edit {
    fill-rule: evenodd;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 1.5;
    clip-rule: evenodd;
  }
`;
const EditIcon = ({ className, ...props }) => {
  const editClassName = classnames(className, editStyles.className, 'edit');
  return (
    <SvgIcon className={editClassName} {...props}>
      <path fill="none" d="M23 6.5L20.5 4l-2 2L21 8.5l2-2z" />
      <path
        fill="none"
        strokeLinecap="square"
        strokeMiterlimit="2"
        d="M20.5 13v7.5h-17v-17h14L18 3H3v18h18v-8.5l-.5.5z"
      />
      <path
        fill="none"
        strokeMiterlimit="2"
        d="M21 8.5L18.5 6l-8 8-.8 3.3 3.3-.8 8-8z"
      />
      {editStyles.styles}
    </SvgIcon>
  );
};

export { EditIcon, TrashIcon };
